import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Page, PageContent, PageHeader, Button, Tabs, Tab, List, Text, Layer, Form, FormField, CheckBoxGroup, Spinner } from "grommet";
import { Announce, Configure, Notification, } from "grommet-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ReverseAnchor } from "../components/competetive/ReverseAnchor";
import { fetchNotifications, markNotificationRead } from "../redux/actions/notificationActions";

function NotificationCenter() {

    // eslint-disable-next-line no-unused-vars
    const history = useHistory()
    const dispatch = useDispatch();
    const session = useSelector((state) => {
        return state.session;
    });
    // const [notifications, setNotifications] = useState()
    const [markasRead, setMarkAsread] = useState(false)
    useEffect(() => {
        if (session && session.user && session.user.access) {
            dispatch(fetchNotifications(session.user.access))
        }
    }, [session, dispatch, markasRead]);
    const { notifications, requestInProgress } = useSelector((state) => {
        return state.notification
    })

    const [showModal, setShowModal] = useState(false);
    const [index, setIndex] = useState(0);
    const onActive = nextIndex => setIndex(nextIndex);
    return (
        <>
            <Page>
                <PageContent gap={"medium"} >
                    <PageHeader title={"Notification Center"} subtitle={"See all your notification here"} parent={<ReverseAnchor label={"Home"} onClick={() => { history.go(-1) }} />}
                    // actions={<Button secondary label="Settings" icon={<Configure />} onClick={() => { setShowModal(true) }} 
                    // />} 
                    />

                    {requestInProgress ? <Spinner /> : <>
                        <Tabs activeIndex={index} onActive={onActive} justify="start">
                            <Tab title="Followed Notifications" icon={<Notification />}>
                                {notifications && Array.isArray(notifications) && notifications.length > 0 ?
                                    <>
                                        <List background="background-front"
                                            data={notifications}
                                            action={(item, index) => { <Text key={index}> {item.message}</Text> }}
                                            onClickItem={e => {
                                                dispatch(markNotificationRead(e.item.id, session.user.access))
                                                window.open(e.item.resource_link)

                                            }}
                                        >
                                            {(datum, index) => (
                                                <Box key={index}>
                                                    <Text size="small" weight={"bolder"}>{datum.type}</Text>
                                                    <Text size="small">{datum.message}</Text>
                                                </Box>
                                            )}
                                        </List>
                                    </> : <>
                                        <Box>
                                            <Text>
                                                No New Notifications !
                                            </Text>
                                        </Box>
                                    </>}
                            </Tab>
                            {/* <Tab title="Announcements" icon={<Announce />}>
                                <Box width={{ max: 'xxlarge' }} margin="auto" fill>
                                    <List
                                        background="background-front"
                                        data={data}
                                        action={(item, index) => <Text key={index}>{item.date}</Text>}
                                        onClickItem={e => {
                                            window.open("https://v2.grommet.io/tabs?theme=hpe#props")
                                        }}
                                    >
                                        {(datum, index) => (
                                            <Box key={index}>
                                                <Text size="small" weight={"bolder"}>{datum.title}</Text>
                                                <Text size="small">{datum.description}</Text>
                                            </Box>
                                        )}
                                    </List>
                                </Box>
                            </Tab> */}
                        </Tabs>
                    </>
                    }


                </PageContent>
                {showModal && <Layer onClickOutside={() => { setShowModal(false) }}>
                    <Box pad={"medium"} gap="medium">
                        <Box>
                            <Text size="large">Settings</Text>
                            <Text>Change setting based on your needs</Text>
                        </Box>
                        <Form >
                            <Box gap="medium">
                                <FormField label="Notification Settings">
                                    <CheckBoxGroup options={['Receive Notifivation via Mail', 'Receive Notification in App']} />
                                </FormField>
                                <Box direction="row" justify="between">
                                    <Button secondary label="Cancel" onClick={() => { setShowModal(false) }} />
                                    <Button type="submit" primary label="Save Settings" onClick={() => { setShowModal(false) }} />
                                </Box>
                            </Box>
                        </Form>
                    </Box>
                </Layer>}
            </Page>
        </>
    );
}

export default NotificationCenter